import { api } from '@/shared/api/generated'
import type { DeviceResponse } from '@/shared/api/generated'

export type { DeviceResponse as Device } from '@/shared/api/generated'

export const devicesApi = {
  list: (): Promise<DeviceResponse[]> => api.listDevices(),

  register: async (browser: string, os: string, userAgent: string) => {
    return api.registerDevice({ browser, os, user_agent: userAgent })
  },

  generatePassword: async (): Promise<string> => {
    const resp = await api.generateDevicePassword()
    return resp.password
  },

  revoke: (deviceId: string): Promise<void> => api.revokeDevice(deviceId),
}
